import React, { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IAxiosError, PageRoutes, roundUpTime, useViewModel } from '../../../utils';
import { Button, TimePicker } from '../../../components';
import { AxiosError } from 'axios';
import { ConfirmationRequest } from '../../../utils/api/requests/ConfirmationRequest';

type TConfirmation = 'ACCEPT' | 'CANCEL' | 'OFFER_TIME';

interface IMeetingConfirmationHash {
  userHash: string;
  meetingHash: string;
  type: TConfirmation;
}

interface IMeetingConfirmationPageProps {
  isOuter?: boolean;
}

export const MeetingConfirmationPage: FC<IMeetingConfirmationPageProps> = ({ isOuter = false }) => {
  const request = useViewModel(ConfirmationRequest);
  const location = useLocation();
  const navigate = useNavigate();
  const [hash, setHash] = useState<IMeetingConfirmationHash>(null);
  const [startDate, setStartDate] = useState(roundUpTime(new Date()));
  const [isOfferTime, setOfferTime] = useState(true);
  const [data, setData] = useState('');

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    const userHash = searchParams.get('consumerId');
    const meetingHash = searchParams.get('meetingId');
    const type = searchParams.get('type') as TConfirmation;

    userHash && meetingHash && type 
      ? setHash({ userHash, meetingHash, type })
      : navigate(PageRoutes.CALENDAR_PAGE);
  }, [location]);

  useEffect(() => {
    answerMeeting();
  }, [hash]);

  const setErrorData = (e: AxiosError<IAxiosError>) => {
    if (e.response.data.code === 'MS_ALREADY_SET_STATUS_ERROR') {
      setData('Извините, вы уже отправили свой ответ!');
    } else {
      setData('Извините, не удалось отправить ваш ответ');
    }
  }

  const answerMeeting = () => {
    if (hash && hash.type !== 'OFFER_TIME') {
      request.answerMeeting(hash.type==='ACCEPT', hash.meetingHash, hash.userHash, isOuter)
        .then(() => {
          const data = hash.type == 'ACCEPT' 
            ? 'Спасибо, вы подтвердили свое участие' 
            : 'Спасибо, вы отказались от встречи';
          setData(data);
        })
        .catch((e: AxiosError<IAxiosError>) => {
          setErrorData(e);
        })
    }
  }

  const onOfferTime = () => {
    request.offerTime(hash.meetingHash, hash.userHash, startDate)
      .then(() => setData('Спасибо, вы предложили свое время'))
      .catch((e: AxiosError<IAxiosError>) => setErrorData(e))
      .finally(() => setOfferTime(false));    
  }

  const redirectToCalendar = () => {
    navigate(PageRoutes.CALENDAR_PAGE);
  }

  return (
    <div className='confirmation-page'>
      {
        hash && hash.type === 'OFFER_TIME' && isOfferTime && ( 
          <div className="offer-time-area">
            <p className='offer-time-message'>Пожалуйста, предложите время, которое вам удобно</p>
            <div className="offer-time-selector-area">
              <TimePicker
                value={startDate}
                onChange={setStartDate}
                readOnly={false}
                isBig
              />
              <Button 
                title="Отправить"
                className="outlined offer-time-button"
                onClick={onOfferTime}
              />
            </div>
          </div>
        )
      }
      {
        hash 
        && (
          hash.type === 'OFFER_TIME' && !isOfferTime ||
          hash.type === 'CANCEL' ||
          hash.type === 'ACCEPT'
        ) 
        && <p className='confirmation-message'>{data}</p>
      }
      {!isOuter && (
        <Button 
          onClick={redirectToCalendar} 
          title='Перейти в календарь' 
          className='medium-long'
        />
      )}
    </div>
  )
} 